import moment from 'moment'
import * as BBApi from '../..'
const rootUrl = BBApi.host + '/oplevalt/cms/pages/'

export type Section = {
	layout: string
	created: string
	updated: string | null
}

export type SectionCreate = any

export const query = async (pageId: number) => {
	const url = rootUrl + pageId + '/sections'
	const response = await BBApi.get(url)
	const sections: any[] = await response.json()

	sections.forEach((section) => {
		if ('counterContainer' in section.content) {
			section.content.counterContainer.date = moment(section.content.counterContainer.date)
		}
	})

	return sections
}

export const create = async (pageId: string, sectionCreate: SectionCreate) => {
	const url = rootUrl + pageId + '/sections'
	const response = await BBApi.post(url, sectionCreate)
	const createdSection = await response.json()
	return createdSection
}

export const update = async (pageId: string, sectionId: string, sectionValues: any) => {
	const url = rootUrl + pageId + '/sections/' + sectionId
	const response = await BBApi.patch(url, sectionValues)
	const sectionUpdate = await response.json()
	return sectionUpdate
}

export const remove = async (pageId: string, sectionId: string) => {
	const url = rootUrl + pageId + '/sections/' + sectionId
	await BBApi.del(url)
}

export const updateOrder = async (pageId: string, sectionIdsUpdates: string[]) => {
	const url = rootUrl + pageId + '/sections'
	await BBApi.patch(url, sectionIdsUpdates)
}

export const copySection = async (pageId: string, sectionId: number) => {
	const url = rootUrl + pageId + '/sections/' + sectionId
	await BBApi.post(url, {})
}
